/**
 * External Dependencies
 */
import 'jquery';
import AOS from 'aos';
$(document).ready(() => {
  // Global constants
  const $document = $(document),
        $window = $(window),
        $body = $('body'),
        $banner = $('#banner'),
        menuToggleId = 'menu-active',
        $menuToggleLabel = $('[for="' + menuToggleId + '"]'),
        $menuToggle = $('#' + menuToggleId),
        breakpointLg = window.matchMedia('(min-width: 1024px)');

  // Set a different class on the banner when scrolled
  const bannerScrollClass = 'scrolled',
        bannerScrollOffset = 100;

  function bannerScroll() {
    if ($document.scrollTop() < bannerScrollOffset) {
      $banner.removeClass(bannerScrollClass);
    } else {
      $banner.addClass(bannerScrollClass);
    }
  }

  $window.scroll(bannerScroll);
  bannerScroll();

  // Automatically open menu drawer when focused on an element inside it to allow keyboard navigation
  $('a, button, label, input, textarea, select').on('focus', (e) => {
    if(!$(e.target).is($menuToggleLabel)) {
      if ($(e.target).closest('#nav').length) {
        $menuToggle.prop('checked', true);
      } else {
        $menuToggle.prop('checked', false);
      }
    }
  });

  // Lock the body on menu toggle to prevent scrolling behind the nav drawer
  const menuToggleActiveClass = 'overflow-hidden';

  $menuToggle.on('change', (e) => {
    if ($(e.target).prop('checked')) {
      $menuToggleLabel.attr('aria-expanded', 'true');
      $body.addClass(menuToggleActiveClass);
    } else {
      $menuToggleLabel.attr('aria-expanded', 'false');
      $body.removeClass(menuToggleActiveClass);
    }
  });

  // NOAA feed
  const $noaaFeed = $('#noaa-feed'),
        $noaaFeedMessage = $('#noaa-feed-message'),
        url = '/wp-json/noaa/v1/feed',
        products = [
          {
            param: 'water_level',
            unit: 'ft. MLLW',
          },
          {
            param: 'air_temperature',
            unit: '°F',
          },
          {
            param: 'water_temperature',
            unit: '°F',
          },
        ];
  
  let fetchProductData = function() {
    if (products.length > 0) {
      let product_index = Math.floor(Math.random() * products.length),
          product = products[product_index];

      $.getJSON(url, {
        product: product.param,
      }).success(function(r) {
        let response = JSON.parse(r);

        if (response.data && response.data.length && response.data[0].v) {
          let message = response.data[0].v + ' ' + product.unit;
    
          $noaaFeedMessage.text(message);
          $noaaFeed.removeClass('opacity-0');
        }
      }).fail(function() {
        products.splice(product_index, 1);
        fetchProductData();
      });
    }
  };

  fetchProductData();

  // Init AOS
  AOS.init({
    disable: function() {
      return breakpointLg.matches === false;
    },
    once: true,
  });

  // Set active styles for FWP dropdowns
  const activeClass = 'is-active';

  // Bind to FWP refresh/loaded events
  $document.on('facetwp-refresh, facetwp-loaded', function() {
    // Add active class to select dropdowns
    $('.facetwp-select-custom').each((i, el) => {
      const $el = $(el),
            $parentEl = $el.closest('.facetwp-facet');

      if (el.value) {
        $parentEl.addClass(activeClass);
      } else {
        $parentEl.removeClass(activeClass);
      }
    });

    const $resetFilters = $('[data-fwp-reset]'),
          activeFilters = Object.values(FWP.facets).filter((val) => { return val.length > 0; });

    if (activeFilters.length > 0) {
      $resetFilters.removeClass('hidden');
    } else {
      $resetFilters.addClass('hidden');
    }
  });

  // Bind FWP handlers if is FWP is active
  if (typeof FWP !== 'undefined') {
    // Custom FWP filters
    $document.on('click', '[data-fwp][data-fwp-value]', (e) => {
      e.preventDefault();

      const facetName = $(e.target).data('fwp'),
            facetValue = $(e.target).data('fwp-value');

      FWP.facets[facetName] = [facetValue];
      FWP.fetchData();
      
      let queryString = FWP.buildQueryString();

      if ('' !== queryString) {
        queryString = '?' + queryString;
      }

      if (history.pushState) {
        history.pushState(null, null, window.location.pathname + queryString);
      }
    });

    // Reset all FWP filters
    $document.on('click', '[data-fwp-reset]', (e) => {
      e.preventDefault();

      FWP.reset();
    });
  }
});
